// Менеджер фоновой музыки меню (Этап 63).
// Один HTMLAudioElement, луп. Играет на всех экранах КРОМЕ боя, громкость
// задаётся ползунком в настройках (corps.musicVolume, 0..100), стартует только
// после первого жеста юзера (браузер и Telegram WebView блокируют автоплей до
// взаимодействия), глушится когда Mini App свёрнут (visibilitychange). Громкость
// 0 = музыка выключена. Звук боя — отдельно (будущая задача).

let audio: HTMLAudioElement | null = null;
let volume = 0.3;     // 0..1, текущая громкость музыки
let inMenu = true;    // false на боевых экранах
let unlocked = false; // был ли первый жест юзера (разблокировка автоплея)
let visible = true;   // Mini App на переднем плане

function clamp01(v: number): number {
  if (!Number.isFinite(v)) return 0;
  return Math.max(0, Math.min(1, v));
}

try {
  const v = localStorage.getItem('corps.musicVolume'); // 0..100
  if (v != null && v !== '') volume = clamp01(Number(v) / 100);
  else volume = localStorage.getItem('corps.music') !== '0' ? 0.3 : 0; // миграция со старого тогла
} catch { /* ignore */ }

function el(): HTMLAudioElement {
  if (!audio) {
    audio = new Audio('/audio/menu.mp3');
    audio.loop = true;
    audio.preload = 'auto';
    // Отладочный хэндл (безвреден) — диагностика воспроизведения музыки.
    try { (window as { __menuAudio?: HTMLAudioElement }).__menuAudio = audio; } catch { /* ignore */ }
  }
  return audio;
}

function apply(): void {
  const a = el();
  a.volume = volume;
  if (volume > 0 && inMenu && unlocked && visible) {
    const p = a.play();
    // play() возвращает Promise; автоплей может быть ещё заблокирован — глушим ошибку.
    if (p && typeof p.catch === 'function') p.catch(() => { /* заблокировано до жеста */ });
  } else {
    a.pause();
  }
}

// Громкость 0..1 (ползунок в настройках).
export function setMusicVolume(v01: number): void { volume = clamp01(v01); apply(); }
export function setMenuActive(on: boolean): void { inMenu = on; apply(); }
export function setAppVisible(on: boolean): void { visible = on; apply(); }
export function unlockAudio(): void { if (!unlocked) { unlocked = true; apply(); } }
